import React from 'react';
import { toDateTimeString } from '../../util/DateUtility';
import './PaymentActivity.css'

export default function PaymentActivity(props) {
    const activities = props.disbursement.activities;
    
    return (
        <div className="efup-payment-side-panel-activities" data-testid="efup-payment-side-panel-activities" tabIndex={0}>
            {activities && activities.map((activity, index) => {
                let displayActivityStart = (activity.activityStart) ? toDateTimeString(activity.activityStart) : null;
                
                return (
                	<div className="efup-side-panel-line" key={`efup-side-panel-activity-${index}`}>
	                     <div className="efup-side-panel-activity-code" data-testid={`efup-side-panel-activity-code-${index}`}>{activity.activityType}</div>
	                     <table className="efup-activity-table table table-borderless">
	        		     	<tbody className="efup-activity-tbody">
		                        <tr>
			                        <td className="efup-side-panel-label" data-testid={`efup-side-panel-activity-description-label-${index}`}>Description:</td>
			                        <td className="efup-side-panel-data" data-testid={`efup-side-panel-activity-description-data-${index}`}>{activity.description}</td>
			                    </tr>
		                        <tr>
			                        <td className="efup-side-panel-label" data-testid={`efup-side-panel-activity-start-date-label-${index}`}>Activity Date:</td>
			                        <td className="efup-side-panel-data" data-testid={`efup-side-panel-activity-start-date-data-${index}`}>{displayActivityStart}</td>
			                    </tr>
	                         </tbody>
	                     </table>
	                </div>
                )
            })}
        </div>
    );
}